

































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Mixins, Watch } from 'vue-property-decorator';
import datePicker from 'vue2-datepicker';
import "vue2-datepicker/scss/index.scss";
import Body from "@/views/layouts/_partials/Body.vue";
import * as _ from "lodash";
import {namespace} from "vuex-class";
import NotificationMixin from "@/mixins/notification.mixin";
import moment from "moment";
import Paginate from "@/components/Paginate.vue";

const Airlines = namespace("AirlineModule");
const Configurations = namespace("ConfigurationsModule");
const OutgoingInvoices = namespace("InvoicesModule");

@Component({
    name: 'Airline',
    mixins: [NotificationMixin],
    components: {
        Body,
        Paginate,
        datePicker
    },
    filters: {
        formatDate: function (value: any) {
            if (!value) {
                return "";
            }
            const cDate = new Date(value);

            return (
                    cDate.getFullYear() +
                    "-" +
                    String(cDate.getMonth() + 1).padStart(2, "0") +
                    "-" +
                    String(cDate.getDate()).padStart(2, "0")
            );
        },
    },
})
export default class Airline extends Mixins(NotificationMixin) {
    loading = false;
    loadingDraft = false;
    languagesSelected: Array<string> = [];
    listLanguagesSelected: Array<string> = [];
    languages: Array<string> = [];

    reportsSelected: Array<string> = [];
    listReportsSelected: Array<string> = [];
    reports: Array<string> = [];
    airlines: Array<string> = [];
    rates: any = [];

    airline: any = [];
    MinDate = '';
    configDay: any = {
        format: 'YYYY-MM-DD',
        defaultDate: this.MinDate,
        minDate: this.MinDate
    };
    Creditline: any = {
        Amount: 0,
        Own: 0,
        Temporarily: 0,
        OneSt: 0,
        TwoNd: 0,
        ThreeRd: 0,
        StopService: 0
    };
    airlineNew: any = {
        AirlinePk: 'Airline',
        AirlineName: '',
        AirlineSk: '',
        ReferenceNumber: '',
        PoNumber: ''
    };
    editCredit = 0;
    config = {format: 'DD/MM/YYYY', minViewMode: 0};
    date: any = null;
    configRate: any = {RateStart: new Date()};
    rateConfig: any = {};
    configRateOld: any = {};
    currencies: Array<string> = [];
    environments: Array<object> = [];
    airlineKey = '';
    envsList: Array<any> = [];
    envs: Array<any> = [];
    editNameAirline = false;
    editConfigAirline = false;

    PriceCashPickUp: any = {
        EUR: [
                true,
            '20-100',
            '101-200',
            '201-300',
            '301-400',
            '401-500',
            '501-2500'
        ],
        GBP: [
                false,
            '20-100',
            '101-200',
            '201-300',
            '301-400',
            '401-500',
            '501-2500'
        ],
        USD: [
                true,
            '20-100',
            '101-200',
            '201-300',
            '301-400',
            '401-500',
            '501-2500'
        ],
        SAR: [
                true,
            '20-100',
            '101-200',
            '201-300',
            '301-400',
            '401-500',
            '501-2500'
        ],
        Price: [
                '',
            '5,22',
            '6,64',
            '8,06',
            '9,48',
            '10,90',
            'Unavailable'
        ]
    };

    AttachmentFile: Array<any> = [];

    showAddNewRate = true;

    private urlRetrieve = 'invoices/outgoing/search';
    protected attachment: File | null = null;
    private invoices = [];
    private SortDate: any = null;
    private filter = {
        Debtor: null,
        InvoiceNr: null,
        FlightNumber: null,
        Airport: null,
        FlightDate: null,
        CreditorName: null,
        Debitor: null,
        Amount: null,
        InvoiceType: null,
        PaidStatus: null,
        RemindersSend: null,
        DateOfPayment: null,
        DueDate: null,
        GetOverDue: false,
        sort: "",
        index: "",
    };
    private CreditorNameList = [];
    private paginate = {
        perPage: 0,
        totalRow: 0,
        currentPage: 0,
        limit: 0,
    };

    mounted() {
        this.getData();
    }

    @Watch('envs')
    async patchEnv() {
        // whenever getDataByRate is called or create new Rate, this if condition is not executed.
        if (!this.configRateOld && this.configRate.StatusRate === 1) {
            this.loading = true;
            this.rateConfig.envs = this.envs
            const result = await this.updateConfigAirline({
                AirlinePk: this.configRate.AirlinePk,
                AirlineSk: this.configRate.AirlineSk, 
                RateConfig: JSON.stringify(this.rateConfig)
            })
            if (Object.prototype.hasOwnProperty.call(result, 'Error')) {
                this.onShowFlashMessage(result.Error, "Error", "danger");
            }
            else {
                const indexToChange = this.rates.findIndex((rate: any) => rate.RateLoca == result.RateLoca)
                this.rates[indexToChange] = result
                this.onShowFlashMessage("Update successfully!");
            }
            this.loading = false;
        }
        this.configRateOld = undefined
    }

    pageChange(params: any) {
        this.getItemPerPage({
            page: params.currentPage,
            filter: this.filterQuery(),
        }).then(
                (response) => {
                    this.invoices = response.invoiceList;
                    if (response.Paginate) {
                        this.paginate = response.Paginate;
                        this.CreditorNameList = this.creditorOptionList;
                    }
                }
        );
    }
    private async addEnv () {
        this.environments.push(this.envsList);
    }

    public sortDate(): void {
        if (this.SortDate == null) {
            this.SortDate = "desc";
        } else {
            this.SortDate = this.SortDate == "desc" ? "asc" : "desc";
        }
        this.filter.sort = this.SortDate;
        this.filter.index = "InvoiceDateSort";
        this.searchData();
    }

    private async removeEnv(key: any) {
        if (this.environments.length - 1 >= key)
            this.environments.splice(key, 1);
        if (this.envs.length - 1 >= key)
            this.envs.splice(key, 1);
    }

    private async addNewRate () {
        this.showAddNewRate = false;
        const newRate = {
            RateStart: this.configRate.RateEnd,
            StatusRate: 0
        };
        this.rates.push(_.clone(newRate));
        this.MinDate = this.configRate.RateEnd
        this.rateConfig = {
            currency: ""
        }
        this.languagesSelected = [];
        this.listLanguagesSelected = [];
        this.reportsSelected = [];
        this.listReportsSelected = [];
        this.envs = [];
        const listEnvs: any  = [];
        listEnvs.push(this.envsList);
        if (!_.isEmpty(this.envs)) {
            let i = 1;
            for (i; i < this.envs.length; i++) {
                listEnvs.push(this.envsList);
            }
        }
        this.environments = listEnvs;
        if (_.isEmpty(this.envs)) {
            this.envs = [''];
        }
        this.configRateOld = this.configRate
        this.configRate = _.clone(newRate);
    }

    private async getDataByAirline(key: any) {
        this.rateConfig = [];
        this.languagesSelected = [];
        this.listLanguagesSelected = [];
        this.reportsSelected = [];
        this.listReportsSelected = [];
        this.airline = _.find(_.clone(this.ListAirlines), function(o) { return o.AirlineSk == key; });
        this.rates = _.filter(this.ListRates, function(o) { return o.AirlineLoca == key; });
        this.rates = _.orderBy(this.rates, ['RateStart'], ['asc']);
        this.environments.push(this.envsList);
        if (!_.isEmpty(this.rates)) {
            this.configRateOld = this.configRate
            this.configRate = _.first(_.clone(_.orderBy(this.rates, ['RateStart'], ['desc'])));
            this.configRate.RateStart = new Date(this.configRate.RateStart);
            this.configRate.RateEnd = this.formatDate(this.configRate.RateEnd);
            this.rateConfig = JSON.parse(this.configRate.RateConfig);
            this.languagesSelected = this.rateConfig.Languages;

            this.reportsSelected = this.rateConfig.Reports;
            this.PriceCashPickUp = !_.isEmpty(this.rateConfig.PriceCashPickUp) ? this.rateConfig.PriceCashPickUp : this.PriceCashPickUp;
            this.envs = this.rateConfig.envs;
            this.Creditline = !_.isEmpty(this.airline.Creditline) ? this.airline.Creditline : this.Creditline;
            this.showAddNewRate = this.configRate.StatusRate == 0 && !_.isEmpty(this.rates) ? false : true;
            const listEnvs: any  = [];
            listEnvs.push(this.envsList);
            if (!_.isEmpty(this.envs)) {
                let i = 1;
                for (i; i < this.envs.length; i++) {
                    listEnvs.push(this.envsList);
                }
            }
            this.environments = listEnvs;

        }
        if (_.isEmpty(this.envs)) {
            this.envs = [''];
        }
        this.addLanguage();
        this.addReport();
    }

    private async getDataByRate(key: any) {
        this.languagesSelected = [];
        this.listLanguagesSelected = [];
        this.reportsSelected = [];
        this.listReportsSelected = [];
        this.configRateOld = this.configRate
        this.configRate = _.find(_.clone(this.rates), function(o) { return o.RateLoca == key; });
        this.configRate.RateStart = new Date(this.configRate.RateStart);
        this.configRate.RateEnd = this.formatDate(this.configRate.RateEnd);
        this.configRateOld = this.rateConfig
        this.rateConfig = JSON.parse(this.configRate.RateConfig);
        this.languagesSelected = this.rateConfig.Languages;
        this.reportsSelected = this.rateConfig.Reports;
        this.PriceCashPickUp = !_.isEmpty(this.rateConfig.PriceCashPickUp) ? this.rateConfig.PriceCashPickUp : this.PriceCashPickUp;
        this.envs = this.rateConfig.envs;
        const listEnvs: any  = [];
        listEnvs.push(this.envsList);
        if (!_.isEmpty(this.envs)) {
            let i = 1;
            for (i; i < this.envs.length; i++) {
                listEnvs.push(this.envsList);
            }
        }
        this.environments = listEnvs;
        if (_.isEmpty(this.envs)) {
            this.envs = [''];
        }
        this.addLanguage();
        this.addReport();
    }

    private disabledDate(date: any) {
        const d = this.MinDate != '' ? this.MinDate : (this.configRate.StatusRate == 0 ? moment().toDate() : this.configRate.RateStart);
       return date <= moment(d).add(-1, 'days')
    }

    private async getData() {
        await this.getConfigAirline();
        await this.getConfig();
        this.languagesSelected = [];
        this.listLanguagesSelected = [];
        this.reportsSelected = [];
        this.listReportsSelected = [];

        this.airlines = _.clone(this.ListAirlines);
        this.languages = _.clone(this.ListLanguages);
        this.reports = _.clone(this.ListReports);
        this.currencies = _.clone(this.ListCurrency);
        this.envsList = _.clone(this.Environments);
        const listEnvs: any  = [];
        listEnvs.push(this.envsList);
        const air: any = _.head(this.airlines)
        this.airline = air;

        if (!_.isEmpty(air)) {
            this.filter.Debtor = this.airline.AirlineSk;
            this.airlineKey = air.AirlineSk;
            this.Creditline = !_.isEmpty(air.Creditline) ? JSON.parse(air.Creditline) : this.Creditline;
            this.rates = _.filter(this.ListRates, function(o) { return o.AirlineLoca == air.AirlineSk; });
            this.rates = _.orderBy(this.rates, ['RateStart'], ['asc']);
        }

        if (!_.isEmpty(this.rates)) {
            this.configRateOld = this.configRate
            this.configRate = _.first(_.orderBy(this.rates, ['RateStart'], ['desc']));
            this.configRate.RateStart = new Date(this.configRate.RateStart);
            this.configRate.RateEnd = this.formatDate(this.configRate.RateEnd);
            this.rateConfig = JSON.parse(this.configRate.RateConfig);
            this.languagesSelected = this.rateConfig.Languages;
            this.reportsSelected = this.rateConfig.Reports;
            this.PriceCashPickUp = !_.isEmpty(this.rateConfig.PriceCashPickUp) ? this.rateConfig.PriceCashPickUp : this.PriceCashPickUp;
            this.envs = this.rateConfig.envs;
            this.showAddNewRate = this.configRate.StatusRate == 0 ? false : true;
            if (!_.isEmpty(this.envs)) {
                let i = 1;
                for (i; i < this.envs.length; i++) {
                    listEnvs.push(this.envsList);
                }
            }

        }
        this.environments = listEnvs;
        if (_.isEmpty(this.envs)) {
            this.envs = [''];
        }
        this.addLanguage();
        this.addReport();
        this.searchData();

    }

    public searchData(): void {
        this.retrieveInvoices(this.filterQuery()).then(
            (response) => {
                this.paginate = response.Paginate;
                this.invoices = response.invoiceList;
                this.CreditorNameList = this.creditorOptionList;
            }
        );
    }

    private filterQuery() {
        const filter = this.filter;
        const filterData: any = {};
        const dateFrom = new Date();
        const searchYear = dateFrom.getFullYear();
        filterData.PartitionKey = searchYear;

        //index using and sort
        if (filter.index) {
            filterData.Index = filter.index;
        }
        if (filter.sort) {
            filterData.Sort = filter.sort;
        }
        filterData.Filter = this.makeFilter();
        if (!filter.GetOverDue) {
            filterData.Filter.push({
                Key: "IsOverDue",
                Value: 0,
            });
        }
        return {url: this.urlRetrieve, filterData: filterData};
    }

    private makeFilter() {
        const filter = this.filter;
        const Filter = [];
        const invoiceNr: any = filter.InvoiceNr;
        const debtor: any = filter.Debtor;
        if (filter.Debtor) {
            Filter.push({
                Key: "Debtor",
                Value: parseInt(debtor),
            });
        }
        if (filter.InvoiceNr) {
            Filter.push({
                Key: "InvoiceNr",
                Value: parseInt(invoiceNr),
            });
        }

        return Filter;
    }

    private addLanguage() {
        const languagesSelected = this.languagesSelected;
        const listLanguagesSelected = this.listLanguagesSelected;
        if (!_.isEmpty(languagesSelected)) {
            const newLang = _.remove(this.languages, function (item) {
                return languagesSelected.indexOf(item) >= 0;
            });
            _.forEach(newLang, function (item) {
                listLanguagesSelected.push(item);
            })
        }
        this.languages = [...this.languages];
        this.languagesSelected = [];
    }

    private removeLanguage() {
        const languagesSelected = this.languagesSelected;
        const languages = this.languages;
        if (!_.isEmpty(languagesSelected)) {
            const oldLang = _.remove(this.listLanguagesSelected, function (item) {
                return languagesSelected.indexOf(item) >= 0;
            });
            _.forEach(oldLang, function (item) {
                if (_.findIndex(languages, item) < 0) {
                    languages.push(item);
                }
            })
        }

        this.listLanguagesSelected = [...this.listLanguagesSelected];
        this.languages = [...this.languages];
        this.languagesSelected = [];
    }

    private addReport() {
        const reportsSelected = this.reportsSelected;
        const listReportsSelected = this.listReportsSelected;
        if (!_.isEmpty(reportsSelected)) {
            const newReport = _.remove(this.reports, function (item) {
                return reportsSelected.indexOf(item) >= 0;
            });
            _.forEach(newReport, function (item) {
                listReportsSelected.push(item);
            })
        }
        this.reports = [...this.reports];
        this.reportsSelected = [];
    }

    private removeReport() {
        const reportsSelected = this.reportsSelected;
        const reports = this.reports;
        if (!_.isEmpty(reportsSelected)) {
            const oldReport = _.remove(this.listReportsSelected, function (item) {
                return reportsSelected.indexOf(item) >= 0;
            });
            _.forEach(oldReport, function (item) {
                if (_.findIndex(reports, item) < 0) {
                    reports.push(item);
                }
            })
        }
        this.listReportsSelected = [...this.listReportsSelected];
        this.reports = [...this.reports];
        this.reportsSelected = [];
    }

    private async saveConfiguartion() {
        this.rateConfig.Languages = this.listLanguagesSelected;
        this.rateConfig.Reports = this.listReportsSelected;
        this.$bvModal.hide('languagesModal');
        this.$bvModal.hide('reportsModal');

    }

    private async saveCreditline() {
        this.loading = true;
        this.airline.Creditline = JSON.stringify(this.Creditline);
        this.updateAirlineConfig();
        this.loading = false;
    }

    private async addNewAirline() {
        this.loading = true;
        this.airline = this.airlineNew;
        this.updateAirlineConfig();
        this.$bvModal.hide('addNewAirlineModal');
    }

    private async updateAirlineConfig() {
        this.loading = true;
        let result: any = [];
        this.airline.AirlinePk = 'Airline';
        _.unset(this.airline, 'RateStart');
        _.unset(this.airline, 'RateEnd');
        _.unset(this.airline, 'RateLoca');
        result = await this.saveConfigAirline(this.airline);

        if (result.success) {
            this.onShowFlashMessage("Successfully!");
        } else {
            this.onShowFlashMessage(result.message, "Error", "danger");
        }
        this.getData();
        this.loading = false;
        this.editNameAirline = false;
        this.editConfigAirline = false;
    }

    private formatDate(value: number) {
        return moment(value).format('YYYY-MM-DD');
    }

    private async saveRateConfigDraft() {
        this.loadingDraft = true;
        if (this.attachment) {
            const uploadAttachment = await this.uploadAttachment(this.attachment);
            if(uploadAttachment.success) {
                this.AttachmentFile.push(uploadAttachment.data[0].Location);
            } else {
                this.loadingDraft = false;
                return false;
            }
        }
        this.rateConfig.envs = this.envs;
        this.rateConfig.AttachmentFile = this.AttachmentFile;
        this.rateConfig.PriceCashPickUp = this.PriceCashPickUp;
        const result = await this.saveConfigAirline({
            AirlinePk: 'Rate',
            AirlineSk: this.configRate.AirlineSk,
            DebtorId: this.airline.AirlineSk,
            RateConfig: JSON.stringify(this.rateConfig),
            RateLoca: this.configRate.RateLoca,
            StatusRate: 0,
            RateStart: this.configRate.RateStart,
            RateEnd: moment(this.configRate.RateStart).add(1,'year').format('YYYY-MM-DD')
        });

        if (result.success) {
            this.onShowFlashMessage("Update configuration successfully!");
        } else {
            this.onShowFlashMessage(result.message, "Error", "danger");
        }
        this.getData();
        this.loadingDraft = false;
    }

    onFileChange(e: any) {
        const file = e.target.files[0];
        console.log(file);
        this.AttachmentFile.push(URL.createObjectURL(file));
        console.log(this.AttachmentFile);
    }

    getDateString(value: Date): string {
        value = value == null ? new Date() : value;
        return (
                value.getFullYear() +
                "-" +
                String(value.getMonth() + 1).padStart(2, "0") +
                "-" +
                String(value.getDate()).padStart(2, "0")
        );
    }

    private async saveRateConfig() {
        this.loading = true;
        if (this.attachment) {
            const uploadAttachment = await this.uploadAttachment(this.attachment);
            if(uploadAttachment.success) {
                this.AttachmentFile.push(uploadAttachment.data[0].Location);
            } else {
                this.loading = false;
                return false;
            }
        }
        this.rateConfig.envs = this.envs;
        this.rateConfig.AttachmentFile = this.AttachmentFile;
        this.rateConfig.PriceCashPickUp = this.PriceCashPickUp;
        const result = await this.saveConfigAirline({
            AirlinePk: 'Rate',
            AirlineSk: this.configRate.AirlineSk,
            DebtorId: this.airline.AirlineSk,
            RateConfig: JSON.stringify(this.rateConfig),
            RateLoca: this.configRate.RateLoca,
            StatusRate: 1,
            RateStart: this.configRate.RateStart,
            RateEnd: moment(this.configRate.RateStart).add(1,'year').format('YYYY-MM-DD')
        });

        if (result.success) {
            this.onShowFlashMessage("Update configuration successfully!");
        } else {
            this.onShowFlashMessage(result.message, "Error", "danger");
        }
        this.getData();
        this.loading = false;
    }

    private async deleteRate(pk: string, sk: string) {
        if(confirm("Are you sure you want to delete this draft?")){
            const result = await this.deleteDraft({
                AirlinePk: pk,
                AirlineSk: sk
            });
            if (result.success) {
                this.onShowFlashMessage("Delete rate draft successfully!");
            } else {
                this.onShowFlashMessage(result.message, "Error", "danger");
            }
            this.getData();
        }
    }

    private hideModal(name: string) {
        switch (name) {
            case 'languages':
                this.listLanguagesSelected = [];
                this.languages = _.clone(this.ListLanguages);
                this.languagesSelected = this.rateConfig.Languages;
                this.addLanguage();
                break;
            case 'reports':
                this.listReportsSelected = [];
                this.reports = _.clone(this.ListReports);
                this.reportsSelected = this.rateConfig.Reports;
                this.addReport();
                break;
            case 'exact':
                break;
            case 'default':
                break;
        }
    }

    @Airlines.State
    public ListAirlines!: any;

    @Airlines.State
    public ListRates!: any;

    @Airlines.State
    public Languages!: Array<string>;

    @Airlines.State
    public ListLanguages!: Array<string>;

    @Airlines.State
    public Reports!: Array<string>;

    @Airlines.State
    public ListReports!: Array<string>;

    @Airlines.State
    public ListCurrency!: Array<string>;

    @Airlines.Action
    public getConfigAirline!: () => Promise<any>;

    @Airlines.Action
    public saveConfigAirline!: (params: object) => Promise<any>;

    @Airlines.Action
    public updateConfigAirline!: (params: object) => Promise<any>;

    @Airlines.Action
    public deleteDraft!: (params: object) => Promise<any>;

    @Configurations.State
    public Environments!: Array<string>;

    @Configurations.Action
    public getConfig!: () => Promise<any>;

    @Airlines.Action
    public uploadAttachment!: (file: File) => Promise<any>;

    @OutgoingInvoices.Action
    public retrieveInvoices!: (params: any) => Promise<any>;

    @OutgoingInvoices.State
    public creditorOptionList!: any;

    @OutgoingInvoices.Action
    public getItemPerPage!: (params: any) => Promise<any>;
}
